exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cell .el-form-item--small.el-form-item[data-v-730bc39e]{margin-bottom:0}.cell-text[data-v-730bc39e]{position:absolute;top:50%;right:0.05208rem;display:inline-block;transform:translateY(-50%)}.el-dialog .el-table[data-v-730bc39e]{margin-bottom:0.09375rem}.input-content[data-v-730bc39e]{padding:0.10417rem 0.05208rem;margin-bottom:0.05208rem;border:0.00521rem solid #E8E8E8;border-radius:0.02083rem}.creat-lookup-table .el-table__header[data-v-730bc39e]{width:100% !important}.creat-lookup-table .el-table__body[data-v-730bc39e]{width:100% !important}\n", ""]);

// exports
